<template>
  <div class="main-content">
    <div :class="{'is-open': isLeftSidebarVisible}" class="mailbox">
      <div class="mailbox-sidebar">
        <!--        <button class="btn btn-theme btn-sm btn-block">Compose</button>-->
        <button type="button" :disabled="taskListUpdating" @click="getAllTasks" class="btn btn-theme btn-sm btn-block">
          {{ taskListUpdating ? 'Обновление...' : 'Обновить' }}
        </button>
        <ul class="sidebar-menu mt-0">
          <li v-for="(group, alias) in groups" @click="openGroup(alias)" v-if="group.badge"
              v-bind:class="{'active': selectedGroup === alias}"><a href="#"><i
            :class="group.icon"></i>
            {{ group.title }}
            <span v-if="group.badge" class="badge badge-pill badge-danger">{{ group.badge }}</span></a></li>
        </ul>

        <a class="left-sidebar-btn" @click="isLeftSidebarVisible = !isLeftSidebarVisible">
          <i
            v-show="!isLeftSidebarVisible"
            class="icon-fa icon-fa-angle-right"
          />
          <i
            v-show="isLeftSidebarVisible"
            class="icon-fa icon-fa-angle-left"
          />
        </a>

      </div>
      <div class="mailbox-content">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-5"/>
        <div v-if="!loading && selectedGroup">
          <div v-if="!displayTasks || !displayTasks.length" class="alert alert-info m-2 text-center">
            <p>Активных задач не найдено</p>
          </div>
          <div class="wrapCollapse">
            <template v-if="selectedGroup === 'salaryCorrection'">
              <SalaryCorrection
                v-if="displayTasks && displayTasks.length"
                :list="displayTasks"
                :removeRecord="(id) => removeRecord(id, 'salaryCorrection')"
              />
            </template>

            <div v-if="selectedGroup === 'drugUpdate'" class="mt-2">
              <UpdateDrugStatusPrice
                :tasks="displayTasks"
                :updateTasksPull="() =>getAllTasks(true)"
              />
            </div>

            <template v-else>
              <table class="table table-hover">
                <tbody>
                <template v-for="(t, i) in displayTasks" v-if="!hiddenSingleTasksTypes[t.type_id]">
                  <tr @click="openTask(i)" class="read hover" v-bind:class="{'active': currentTask === i}">
                    <td class="cell-user"><a class="user"><img src="/assets/img/avatars/avatar.png"
                                                               class="user-avatar"></a>
                    </td>
                    <td class="cell-content">
                      <div class="content">
                        <div class="content-name">
                          <template v-if="!hideNames">
                            <UserName v-if="t.created_by" :id="t.created_by"/>
                            <template v-if="usersForReply[t.id]">
                              <span> / </span>
                              <span
                                v-if="usersForReply[t.id].user.id !== t.created_by">{{
                                  usersForReply[t.id].user.name
                                }}</span>
                              <span>( {{ $AllDivisions[usersForReply[t.id].division_id]?.title }} )</span>
                            </template>
                          </template>
                        </div>
                        <div class="content-subject">
                          ({{ t.type_id }}) <strong>{{ taskAlias[t.type_id] }}</strong>
                          <span class="badge badge-info">{{ (t?.dialog?.messages ?? []).length }}</span>
                        </div>
                        <div>
                          <div v-html="getSmallTaskDescription(t)"/>
                          <div class="flex flex_gap_10">
                            <span class="text-muted">{{ t.id }}</span>
                            <TasksSubStatuses :task="t" type="display" v-if="t.sub_status"/>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="cell-time">{{ printDate(t.created_at) }}</td>
                    <td class="cell-attachment">
                    </td>
                  </tr>
                  <tr class="noHover" v-if="currentTask == i">
                    <td colspan="10">

                      <GlobalTaskView :task="t" :getAllTasks="getAllTasks" :groups="groups" :currentTask="currentTask"/>

                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import api from "@/api";
import Messages from "@/components/chat/components/Messages";
import UserName from "@/components/users/UserName";
import LoadingButton from "@/components/buttons/LoadingButton";
import SalaryCorrection from "@/views/tasks/components/SalaryCorrection";
import PrePaidButton from "@/components/orders/prePaid/PrePaidButton";
import DiffPriceNoCashPrice from "@/views/tasks/components/DiffPriceNoCashPrice.vue";
import CashOrderWithSMS from "@/views/tasks/components/CashOrderWithSMS.vue";
import DrugInInvoice from "@/views/tasks/components/DrugInInvoice.vue";
import UpdateDrugStatusPrice from "@/views/tasks/components/UpdateDrugStatusPrice.vue";
import SimpleTaskWithComment from "@/views/tasks/components/SimpleTaskWithComment.vue";
import AddSupplierCodes from "@/views/tasks/components/AddSupplierCodes.vue";
import ManufacturerDrugInfoTask from "@/views/tasks/types/ManufacturerDrugInfoTask.vue";
import PairDrug from "@/views/statistics/components/tasksType/PairDrug.vue";
import DisabledDrugsList from "@/views/tasks/components/DisabledDrugsList.vue";
import TasksSubStatuses from "@/views/tasks/components/TasksSubStatuses.vue";
import GlobalTaskView from "@/views/tasks/components/GlobalTaskView.vue";

export default {
  title: 'Задачи',
  components: {
    GlobalTaskView,
    TasksSubStatuses,
    DisabledDrugsList,
    PairDrug,
    AddSupplierCodes,
    SimpleTaskWithComment,
    UpdateDrugStatusPrice,
    UserName,
    Messages,
    LoadingButton,
    SalaryCorrection,
    PrePaidButton,
    DiffPriceNoCashPrice,
    CashOrderWithSMS,
    DrugInInvoice,
    ManufacturerDrugInfoTask,
  },
  beforeDestroy() {
    this.$socket.client.off('personal_user_' + this.$currentUID)
  },
  mounted() {
    this.$socket.client.on('personal_user_' + this.$currentUID, (payload) => {
      this.handleNotification(payload)
    })
    this.hideSidebarOnMobile();
  },
  data() {
    return {
      taskListUpdating: false,
      isLeftSidebarVisible: true,
      loading: false,
      btnLoading: false,
      currentTask: null,
      hideNames: true,
      usersForReply: {},
      allTasks: [],
      displayTasks: [],
      records: {},
      taskAlias: {
        3: 'Коррекция расчета ЗП',
        4: 'Коррекция препаратов в заявке',
        5: 'Диалог с курьером',
        6: 'Коррекция препаратов от курьера',
        7: 'Диалог Менеджер/Курьер',
        11: 'Рассинхрон стоимости заявки и реквизитов карты',
        12: 'Заявка за наличные с оплатой по карте',
        14: 'Препарат проведен с превышением остатка на складе',
        17: 'Обновление препрата цена/активность',
        19: 'Отправка заявки по почте',
        22: 'Позвонить по наличию',
        23: 'Собрать данные по стоимости',
        24: 'Привязать артикулы',
        26: 'Клиент не может оплатить заявку',
        27: 'Привязка препарата к базе',
        31: 'Препараты деактивированы',
      },
      groups: {
        allTasks: {title: 'Все', icon: 'icon-fa icon-fa-inbox', badge: 0},
        salaryCorrection: {title: 'Коррекция ЗП', group: 1, type: 3, icon: 'icon-fa icon-fa-send', badge: 0},
        myTasks: {title: 'Мои задачи', icon: 'icon-fa icon-fa-hand-pointer-o', badge: 0},
        drugUpdate: {group: 6, title: 'Препараты', icon: 'icon-fa icon-fa-medkit', badge: 0},
        tasksFromManagers: {group: 2, title: 'Менеджеры', icon: 'icon-fa icon-fa-users', badge: 0},
        tasksFromRunners: {group: 1, title: 'Курьеры', icon: 'icon-fa icon-fa-send', badge: 0},
        // tasksFromSupervisors: {types: [5], title: 'Контролеры', icon: 'icon-fa icon-fa-user-secret', badge: 0},
        // tasksToRunners: {types: [5], title: 'Курьеры', icon: 'icon-fa icon-fa-user-secret', badge: 0},
        diffPrices: {group: -1, title: 'Оплата', type: 11, icon: 'icon-fa icon-fa-money', badge: 0},
        orderByCashWSms: {group: -1, title: 'Реквизиты', type: 12, icon: 'icon-fa icon-fa-money', badge: 0},
        sendOrderByPost: {group: 7, title: 'Отправка з.', type: 19, icon: 'icon-fa icon-fa-dropbox', badge: 0},
      },
      hiddenSingleTasksTypes: {17: true},
      selectedGroup: null
    }
  },
  created() {
    if (this.$currentUserRoles.includes('supervisor')
      || this.$currentUserRoles.includes('manager')
      || this.$currentUserRoles.includes('managerAssist')
      || this.$currentRole === 'admin'
    ) {
      this.hideNames = false;
    }
    this.getAllTasks();
  },
  methods: {
    getUsersForReply() {
      this.allTasks.forEach((t) => {
        t.users.forEach((u) => {
          if (u.user?.detail?.details) {
            this.usersForReply[t.id] = {
              user: u.user,
              division_id: u.user.detail.details
            };
          }
        })
      });
    },
    getSmallTaskDescription(task) {
      switch (+task.type_id) {
        case 22:
        case 23:
        case 24:
          return task.task_data?.drug?.title;
      }
      return '';
    },
    removeRecord(id, group = null) {
      this.sortTasks(this.allTasks.filter((t) => t.id !== id), group);
    },
    handleNotification(data) {
      console.log(data);
    },
    openTask(index) {
      if (+index === this.currentTask) return;
      this.currentTask = null;
      setTimeout(() => {
        this.currentTask = index;
      }, 100)
    },
    updateRecords(records) {

    },
    sortTasks(records, selectGroup = null) {
      Object.keys(this.groups).forEach((g) => {
        this.groups[g].badge = 0;
      })
      this.records = records.reduce((acc, r) => {
        if (r.created_by === this.$currentUID) {
          if (!acc.myTasks) acc.myTasks = [];
          acc.myTasks.push(r);
          return acc;
        }
        let sorted = false;
        Object.keys(this.groups).forEach((g) => {
          if (sorted) return;
          if (this.groups[g].group === r.group) {
            if (this.groups[g].type) {
              if (this.groups[g].type === r.type_id) {
                if (!acc[g]) acc[g] = [];
                acc[g].push(r);
                sorted = true;
              }
            } else {
              if (!acc[g]) acc[g] = [];
              acc[g].push(r);
              sorted = true;
            }
          }
          if (!sorted) {
            if (this.groups[g].type && this.groups[g].type === r.type_id) {
              if (!acc[g]) acc[g] = [];
              acc[g].push(r);
              sorted = true;
            }
          }
        })
        return acc;
      }, {})
      this.allTasks = records;
      Object.keys(this.records).forEach((g) => {
        this.groups[g].badge = this.records[g].length;
      })
      this.groups.allTasks.badge = records.length;
      if (selectGroup) {
        this.openGroup(selectGroup);
      }
    },
    async getAllTasks(silent = false) {
      this.loading = !silent;
      this.taskListUpdating = true;
      const {data} = await api.index('/tasks/all');
      if (data.success) {
        Object.keys(this.groups).forEach((g) => {
          this.groups[g].badge = 0;
        })
        this.sortTasks(data.records);
        if (!silent) {
          this.openGroup('allTasks');
        } else {
          this.displayTasks = this.selectedGroup === 'allTasks' ? [...this.allTasks] : [...(this.records[this.selectedGroup] || [])];
        }
        this.getUsersForReply();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
      this.taskListUpdating = false;
    },
    openGroup(group) {
      this.currentTask = null;
      this.selectedGroup = group;
      this.displayTasks = group === 'allTasks' ? [...this.allTasks] : [...(this.records[group] || [])];
    },
    hideSidebarOnMobile() {
      let self = this
      window.onresize = function () {
        if (window.innerWidth <= 992) {
          self.isLeftSidebarVisible = false
        }
      }
    }
  }
}

</script>

<style scoped>
.mailbox .mailbox-sidebar .sidebar-menu li {
  padding: 0 5px;
}

.wrapCollapse dd {
  padding: 0 20px;
  height: 0;
  transition: all .2s ease;
  overflow: hidden;
  opacity: 0;
}

.wrapCollapse dd.active {
  height: auto;
  padding: 10px 20px 20px;
  opacity: 1;
}

tr.active,
.mailbox .mailbox-content .table tr.active:hover {
  background-color: #343A52 !important;
  color: white;
}

tr.noHover {
  cursor: default !important;
  //pointer-events: none;
}

tr.active .content-subject,
tr.active:hover .content-subject {
  color: white !important;
}

a.left-sidebar-btn {
  text-decoration: none;
  background-color: #343A52 !important;
  color: white !important;
}

.content-name {
  font-weight: 400 !important;
}

.left_task_part {
  min-width: 165px;
  padding-right: 10px;
}
</style>
